import { createAction, createAsyncAction } from 'typesafe-actions';
import { LinkedPagesResponse } from '../types';

const LINKED_PAGES_REQUEST = 'linkedPages/FETCH_LINKED_PAGES/request';
const LINKED_PAGES_SUCCESS = 'linkedPages/FETCH_LINKED_PAGES/success';
const LINKED_PAGES_FAILURE = 'linkedPages/FETCH_LINKED_PAGES/failure';
const LINKED_PAGES_CANCEL = 'linkedPages/FETCH_LINKED_PAGES/cancel';
const LINKED_PAGES_RESET = 'linkedPages/RESET_LINKED_PAGES';

export const FETCH_LINKED_PAGES = createAsyncAction(
  LINKED_PAGES_REQUEST,
  LINKED_PAGES_SUCCESS,
  LINKED_PAGES_FAILURE,
  LINKED_PAGES_CANCEL,
)<void, LinkedPagesResponse, Error, void>();

export const RESET_LINKED_PAGES = createAction(LINKED_PAGES_RESET)<void>();
